interface Props {
  totalItems: number;
  onCartOpen: () => void;
}

export default function StoreHero({ totalItems, onCartOpen }: Props) {
  return (
    <section className="relative h-[420px] flex items-end overflow-hidden">
      <img
        src="/images/kitchen/cooking-range.webp"
        alt="ISMAN Store"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10"></div>
      <div className="relative w-full max-w-7xl mx-auto px-6 pb-14 flex items-end justify-between gap-4">
        <div>
          <span className="inline-block bg-teal-600 text-white text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-md mb-4">
            ISMAN Engineering Store
          </span>
          <h1 className="text-white text-4xl md:text-5xl font-bold leading-tight mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Engineering Equipment &amp; Services
          </h1>
          <p className="text-white/80 text-base max-w-xl">
            Browse and order professional-grade stainless steel equipment, HVAC solutions, hospital fittings, and design services — directly from Kenya&apos;s trusted engineering specialists.
          </p>
        </div>
        <button
          onClick={onCartOpen}
          className="relative bg-white/20 hover:bg-white/30 text-white text-sm font-semibold px-5 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 shrink-0"
        >
          <i className="ri-shopping-basket-line text-lg"></i>
          View Cart
          {totalItems > 0 && (
            <span className="absolute -top-2 -right-2 bg-teal-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
              {totalItems}
            </span>
          )}
        </button>
      </div>
    </section>
  );
}
